import { render } from "./Plant.vue?vue&type=template&id=59df2216&ts=true"
import script from "./Plant.vue?vue&type=script&lang=ts"
export * from "./Plant.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__